import { useMemo } from "react";
import { convertToGalleryItemList } from "./../../_shared/media/convert-to-gallery-item-list.js";
function useItems({
  items,
  relValue,
  anchorTarget,
  baseUrl
}) {
  const galleryItems = useMemo(() => {
    return convertToGalleryItemList({ items, relValue, anchorTarget, baseUrl });
  }, [items]);
  return galleryItems;
}
export {
  useItems
};
//# sourceMappingURL=use-items.js.map
